import React, { PureComponent } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import Loader from 'src/ver2/components/loader';
import TrefaText from 'src/ver2/components/trefaText';
import PersonInventar from './components/personInventar';
import Quest20 from './components/quest20';
import Quest27 from './components/quest27_statua';
import Quest36 from './components/quest36_face';
import Quest66 from './components/quest66_circle';
import Quest103 from './components/quest103_houses';
import MainAdmin from './components/mainadmin';
import Results89 from './components/results89';
import Quest96 from './components/quest96_fort';
import Quest207 from './components/quest207_laz';
import Quest211 from './components/quest211_light';
import Quest222 from './components/quest222_moondore';
import Quest254 from './components/quest254_lamp';
import Quest259 from './components/quest259_bridge';
import Quest335 from './components/quest335_code';
import Quest339 from './components/quest339_code';

import Charater from '../island/components/characters';
import Parallax from '../island/components/parallax';

import Pump from 'src/ver2/components/halloween';

import NgGameRPG from 'src/ver2/pages/test/nggame/inisland';
import ShopPage from './screen/shop';

import { message, Tabs, Modal } from 'antd';
import { Link } from 'react-router-dom';
import './styles.css';

const TabPane = Tabs.TabPane;

// const TIMERTICK = 5;
const ISLAND_LOC = {
    1: {
        1: { x: 146, y: 800 },
        2: { x: 59, y: 800 },
        3: { x: 237, y: 773 },
        4: { x: 99, y: 654 },
        5: { x: 500, y: 642 },
        6: { x: 380, y: 613 },
        7: { x: 615, y: 770 },
        8: { x: 672, y: 617 },
        9: { x: 215, y: 427 },
        10: { x: 284, y: 512 },
        11: { x: 902, y: 608 }
    },
    2: {
        12: { x: 532, y: 622 },
        13: { x: 532, y: 518 },
        14: { x: 590, y: 484 },
        15: { x: 440, y: 475 },
        16: { x: 305, y: 538 },
        17: { x: 257, y: 606 },
        18: { x: 227, y: 696 },
        19: { x: 306, y: 730 },
        20: { x: 527, y: 760 },
        21: { x: 859, y: 741 },
        22: { x: 740, y: 545 }
    },
    3: {
        25: { x: 204, y: 630 },
        26: { x: 449, y: 552 },
        27: { x: 307, y: 471 },
        28: { x: 407, y: 387 },
        29: { x: 534, y: 431 },
        30: { x: 634, y: 545 },
        31: { x: 568, y: 793 },
        32: { x: 714, y: 777 },
        33: { x: 500, y: 826 },
        34: { x: 375, y: 901 },
        35: { x: 400, y: 805 },
        36: { x: 302, y: 805 },
        37: { x: 636, y: 793 },
        38: { x: 440, y: 892 }
    },
    4: {}
}

class IslandPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            combineMode: null,
            screenWidth: 100,
            screenHeight: 100,
            Items: [],
            myActions: [],
            miniMapFull: false,
            showMenu: false,
            windowWidth: document.documentElement.clientWidth,
            islandPass: false
        }

        this.IslandId = 1;
        if (props && props.match && props.match.params && props.match.params.islandId) {
            this.IslandId = props.match.params.islandId;
        }

        if (this.IslandId === 3 || this.IslandId === '3')
            window.onresize = () => {
                this.setState({
                    windowWidth: document.documentElement.clientWidth
                })
            }

    }

    setStarsTimer = () => {
        this.StarsTimer = setInterval(() => {
            const { iamuser, renewResourses } = this.props;
            if (iamuser) renewResourses();
        }, 10000);
    }

    init = async () => {
        const { client, iamuser } = this.props;

        const whereAmI = await client.getIslandWhereAmI(this.IslandId);
        if (whereAmI && whereAmI.IslandId && whereAmI.LocationId) {
            console.log('whereAmI', { whereAmI })
            await this.loadItems();
            const myActions = await client.islandGetUserActions({ IslandId: this.IslandId });
            this.setState({
                status: 'loaded',
                myActions,
                ...whereAmI
            })
            return;
        }

        if (!iamuser || !iamuser.Id) {
            return this.setState({ status: 'nouser' })
        }

        return this.setState({ status: 'noislanduser' })
    }

    loadItems = async () => {
        const { client, iamuser } = this.props;

        if (!iamuser) return null;

        const { Id } = iamuser;

        const itemsResult = await client.getAllUserItems(Id);
        if (!itemsResult) return this.setState({ Items: [] });

        let Items = [];

        // теперь мы в каждый дописываем абстрактный объект с сервера
        for (let i = 0; i < itemsResult.length; i++) {
            if (itemsResult[i].IslandId !== Number(this.IslandId)) continue;
            const abstrItem = client.getAbstractItem(itemsResult[i].Name);
            if (abstrItem) {
                Items.push({
                    ...abstrItem,
                    ...itemsResult[i],
                    name: itemsResult[i].Name
                })
            }
        }

        Items.reverse();
        this.setState({ Items });
    }

    setCompineMode = (combineMode = null) => {
        this.setState({ combineMode })
    }

    toggleMiniMapFull = () => {
        this.setState({ miniMapFull: !this.state.miniMapFull })
    }
    toggleShowMenu = () => {
        this.setState({ showMenu: !this.state.showMenu })
    }

    componentDidMount() {
        this.init();
        this.setScreenSized();
        if (Number(this.IslandId) === 2) {
            this.setStarsTimer();
        }
        this.props.doShowFooter(false);
    }

    componentDidUpdate = ({ iamuser }) => {
        if (!iamuser && this.props.iamuser) {
            this.init();
        }
    }

    componentWillUnmount() {
        clearInterval(this.StarsTimer);
        this.StarsTimer = null;
        delete this.StarsTimer;
        this.props.doShowFooter(true);
    }

    islandLogOnIsland = async () => {
        const { client } = this.props;
        const { IslandId } = this;
        const res = await client.islandLogOnIsland({ IslandId })
        if (res && res.Message) {
            message.success('Добро пожаловать')
            this.init();
        } else {
            message.error('Ошибка сервера')
            this.setState({ status: 'noislanduser' });
        }
    }

    makeAChoose = ({ ChooseId }) => {
        const { client } = this.props;
        this.setState({ status: 'waiting' });
        const { IslandId } = this;
        client.islandMakeAChoose({ IslandId, ChooseId }).then(() => {
            this.init();
        })
    }

    sendSpecial = ({ data }) => {
        const { client } = this.props;
        this.setState({ status: 'waiting' });
        const { IslandId } = this;
        client.islandMakeAChoose({ IslandId, Special: data }).then((result) => {
            if (result && (result.length || result.Message)) {
                message.success(result.Message)
                this.init();
            } else {
                this.setState({ status: 'loaded' });
                message.error('Неверный ответ')
            }
        })
    }

    useItem = ({ ItemId }) => {
        const { client } = this.props;
        this.setState({ status: 'waiting' });
        const { IslandId } = this;
        client.islandUseItem({ IslandId, ItemId }).then((result) => {
            console.log('islandUseItem', { result });
            if (result && (result.length || result.message)) {
                this.init();
            } else {
                this.setState({ status: 'loaded' });
                message.error('Нельзя применить тут')
            }
        })
    }

    addCombineItem = ({ ItemId }) => {
        const { client } = this.props;
        const { IslandId } = this;
        let combineMode = this.state.combineMode ? { ...this.state.combineMode } : {};
        if (!combineMode) combineMode = {};
        combineMode[ItemId] = true;

        if (Object.keys(combineMode).length > 1) {
            this.setState({ status: 'waiting' });
            const values = Object.keys(combineMode);
            const Item1Id = values[0];
            const Item2Id = values[1];
            this.setCompineMode();
            client.islandCombineItems({ IslandId, Item1Id, Item2Id }).then((result) => {
                if (result && (result.length || result.Message)) {
                    message.success(result.Message)
                    this.init();
                } else {
                    this.setState({ status: 'loaded' });
                    message.error('Не получается скомбинировать')
                }
            })
            return;
        }

        this.setState({ combineMode })
    }

    setScreenSized = () => {
        const { isMobile } = this.props;
        if (isMobile) {
            this.setState(
                {
                    screenWidth: isMobile.width,
                    screenHeight: isMobile.height
                }
            );
            return;
        }

        const screenWidth = 500;
        const koef = 1.5;

        return this.setState(
            {
                screenWidth,
                screenHeight: screenWidth * koef
            }
        );
    }

    render() {

        const { client, isMobile } = this.props;
        const { status } = this.state;

        if (status === 'loading') {
            return <div className='island_main'>
                <Loader text='Загрузка игры' />
            </div>
        }

        let passToIsland = false;

        if (this.IslandId === 1 || this.IslandId === '1' || this.IslandId === 2 || this.IslandId === '2' || this.IslandId === 4 || this.IslandId === '4') {

            let trefaText = `^a_^text^a_^Приветствую Вас на Острове!^n_^^n_^Это первый интерактивный квест на портале, в ходе которого
        Вам предстоит ходить по затерянному в неизвестных водах острову и решать головоломки, применяя как свою эрудицию и знания базовых 
        аспектов капоэйры, так и удачу и находчивость.^n_^Не все задания решаются тривиально, в квесте немалое количество текста, так что запаситесь
        терпением.^n_^Если совсем где-то застряли - пишите администрации, намекну прохождение ;)^n_^^n_^По прибытии на Остров - загляните сразу в раздел
        помощи и ознакомтесь с управлением. Оно не сложное и с ним быстро можно разобраться.^n_^^n_^Квестовые острова подразумевают не только работу головой, но
        и ногами. Башенки, которые Вы увидите на карте, связаны с возможностью заявить соло-связки, которые Вам предстоит выполнить и отправить видео, но обо всем по порядку,
        сначала дойдите до них!^n_^^n_^Надеюсь, Вам понравится квест! При должной обратной связи, такие мероприятия можно будет делать регулярно, а функционал значительно расширять,
        есть множество идей, сейчас это только совсем базовая тестовая версия.^n_^^n_^Удачи в прохождении!`

            if (this.IslandId === 2 || this.IslandId === '2') {
                trefaText = `^a_^text^a_^Это квест, созданный для Самарского летнего лагеря 2023^n_^`;
            }

            if (status === 'nouser') {
                const trefaText2 = `^a_^text^a_^Вы не вошли в свой аккаунт. Вернитесь на главную страницу портала и войдите в аккаунт, или пройдте стандартную процедуру регистрации, после 
            чего возвращайтесь сюда, Остров Вас ждёт!`;

                const width = isMobile ? isMobile.width * 0.95 : 1000;
                let style = {};
                if (isMobile) {
                    style = {
                        height: isMobile.height
                    }
                }

                return <div style={style} className='island_main'>
                    <div className='island_main_startscreen'>
                        <this.Board trefaText={trefaText} width={width} />
                        <this.Board trefaText={trefaText2} width={width} />
                        <Link to='/'>
                            <this.Board text={'ВЕРНУТЬСЯ НА ГЛАВНУЮ'} width={width} isChoose={true} />
                        </Link>
                    </div>
                </div>
            }

            if (status === 'noislanduser') {
                const width = isMobile ? isMobile.width * 0.95 : 1000;
                let style = {};
                if (isMobile) {
                    style = {
                        height: isMobile.height
                    }
                }
                return <div style={style} className='island_main'>
                    <div className='island_main_startscreen'>
                        <this.Board trefaText={trefaText} width={width} />
                        <this.Board text={'СТУПИТЬ НА ОСТРОВ'} width={width} isChoose={true} onClick={() => {
                            this.setState({ status: 'loading' });
                            this.islandLogOnIsland();
                        }} />
                    </div>
                </div>
            }

            passToIsland = true;

        }

        if (this.IslandId === 3 || this.IslandId === '3') {
            const { windowWidth } = this.state;
            const elementWidth = Math.min(isMobile ? isMobile.width : windowWidth, 1500) * 0.8;

            if (!this.state.islandPass) {

                const trefaText3_1 = `
                ^a_^text^a_^Старинные свитки хранят в себе записи о Подземелье Тотемов. ^n_^^n_^Древние духи животных, когда-то обитавшие здесь, оставили задания для самых сильных, ловких и сообразительных Воинов. ^n_^^n_^Сможешь ли Ты и Твоя команда пройти испытания и заполучить себе все Тотемы ?!
                `

                const trefaText3_2 = `
                ^a_^text^a_^Челлендж Тотемы - это крупное онлайн мероприятие на портале Capoeirasport, запланированное на начало 2024 года. В ходе прохождения  участникам придётся выполнять различные задания, распределённые по уровню сложности, включающие в себя как знакомые механики составления связок, так и новые: выполнение определённого капоэйра-упражнения на время и количество, физические нормативы, набор необходимых очков в связках, парные связки, сюжетный онлайн квест и т.д.^n_^^n_^У каждого животного - свой Тотем и свои задания, включающие 4 ступени (деревянный Тотем, бронзовый, серебряный и золотой), градирующие варианты выполнения от тех, что подойдут совсем новичкам, заканчивая теми, которые способны заставить попотеть опытных капоэйристов. Лев потребует выполнять скоростные ударные связки, черепаха - упражнения на балансы, рыбы - синхронное выполнение связкок двумя капоэйристами и так далее.^n_^^n_^Все проходящие челлендж капоэйристы будут премированы специальными игровыми очками, на которые можно приобрести уникальные виртуальные предметы, а самые проворные участники, группы и школы получат дополнительные возможности на портале (такие как добавление индивидуальных мерч-предметов в виртуальные магазины)^n_^^n_^Выполнение всех заданий подтверждается отправленным видео упражнения или связки в Телеграм канал ФКР, а инструкторы групп смогут самостоятельно подтверждать выполнение заданий своими учениками на первые два уровня сложности.^n_^^n_^Более подробное описание будет составлено перед стартом челленджа.`

                const trefaText3_3 = `^a_^image^a_^^s_https://capoeirasport.com/graphics/totems.png^^w_100%^^h_auto^`;

                const trefaText3_4 = `
                ^a_^text^a_^Один из Тотемов - Тотем Духа Совы - подразумевает прохождение онлайн квеста, ведь хороший капоэйрист работает не только ногами, но и головой. В качестве предварительной демонстрации и запуска Новогоднего ивента - у пользователей портала есть возможность пройти DEMO версию данного квеста, включающую в себя примерно половину загадок полноценной версии, которая будет доступна при старте Челленджа. По успешному прохождению DEMO версии участник награждается новогодней виртуальной игрушкой.^n_^^n_^БУДЬТЕ ВНИМАТЕЛЬНЫ! Как только начнётся подготовка к запуску всего Челленджа, квест будет переведён к финальному варианту,  а все данные и прогресс игроков (кроме призовых игрушек) будут удалены - финальный квест придётся проходить заново с нуля. Тем более, в нём могут быть отличия от DEMO версии даже в тех местах, где Вы уже прошли.^n_^^n_^Для прохождения квеста - нажмите кнопку снизу. Если это первый раз, когда вы играете в квест на портале, и еще не проходили Остров - прочитайте сначала краткое руководство по игре, оно приведено ниже кнопки. И учтите, что появилась новая механика щелчка по экрану! Удачи!
                `

                const trefaText3_5 = `
                ^a_^text^a_^Весь квест поделён на локации, каждая снабжена картинкой и текстом, описывающими то, где Вы находитесь, и что сейчас происходит. В каждой локации Вам на выбор предлагается набор действий или фраз, которые Вы можете совершить или сказать. Выбирая различные варианты, Вы продвигаетесь по карте, или развиваете текущую ситуацию.^n_^В квесте Тотем Духа Совы также появляется новая механика - интерактивные объекты. Если что-то на экране локации кажется Вам подозрительным или интересным, Вы можете попробовать туда нажать. Если Вы попадаете в интерактивный объект, с ним начинается то или иное взаимодействие.^n_^^n_^ПРЕДМЕТЫ^n_^Во время прохождения Квеста Вам встречаются предметы, которые Вы убираете в свой инвентарь. ^n_^Предметы делятся на два типа:^n_^ ^n_^Предметы с иконкой Q подразумевают реальные вещи, которые Вы носите с собой.^n_^^n_^Предметы с иконкой диалога подразумевают какую-либо информацию: мысль, идею, тему для диалога.^n_^^n_^Предметы можно рассмотреть, а также применить в данной локации. Нажимая на кнопку применения Вы, подразумеваете, что Ваш персонаж использует данный предмет в текущей локации согласно контексту ситуации.^n_^^n_^ПРИМЕР ПРЕДМЕТОВ^n_^Вы стоите около болота, Ваш персонаж не знает, как его пересечь. Вы выбираете вариант идти в лес. Находясь в лесу, Вы нажимаете из предложенных вариантов Обыскать соседнее дерево, и, как результат, находите там Наручные часы, которые убираете в инвентарь. Далее Вы продвигаетесь к местному жителю, стоящему на опушке. Начинаете с ним диалог, в ходе которого он говорит, что потерял в лесу часы. Мы применяете предмет Часы в диалоге, подразумевая, что Ваш персонаж предложит их жителю. Житель благодарит Вас за часы и говорит, что если в соседнем болоте наступать только на нечетные кувшинки, Вы сможете пройти. Ваш персонаж добавляет данную информацию, как оформленную мысль в инвентарь. Вы идёте в локацию болота, применяете там этот предмет и персонаж, соотнеся информацию и контекст ситуации, проходит через болото, наступая только на нечетные кувшинки.^n_^^n_^ЛОГИ^n_^В логах описаны все ключевые действия, которые совершил Ваш персонаж. Ключевыми называются действия, которые могут влиять на ход игры. Например, Вы подходите к двери - она закрыта. Уходите в соседний экран, дёргаете рубильник, совершая действие Вы дёрнули рубильник, он заносится в лог. Возвращаетесь к двери в ту же локацию, дверь становится открытой, а у Вас добавляется вариант Пройти дальше. Не все ключевые действия обязательно влияют на какую-то локацию в квесте, иногда они записываются просто для того, чтобы игрок мог их вспомнить.^n_^^n_^КАРТА^n_^В квесте присутствует карта, позволяющая сориентироваться, где в данный момент относительно всего игрового мира находится игрок. В версии на ПК карта выведена в отдельный экран, в версии для мобильного телефона - всегда полупрозрачно находится в верхнем левом углу и расширяется при клике.
                `
                const trefaText3_nouser = `^a_^text^a_^Вы не вошли в свой аккаунт. Вернитесь на главную страницу портала и войдите в аккаунт, или пройдте стандартную процедуру регистрации, после 
            чего возвращайтесь сюда, Остров Вас ждёт!`;

                return <div className='island_main island_main_island3'>
                    <div className='island_main_island3_inner'>
                        <Parallax width={isMobile ? isMobile.width : windowWidth} />
                        <div style={{ width: elementWidth }}>
                            <TrefaText trefaText={trefaText3_1} style={{ color: 'white', fontSize: isMobile ? 18 : 30 }} />
                        </div>
                        {(status !== 'nouser' && status !== 'noislanduser') &&
                            <this.Board text={'ПРОДОЛЖИТЬ КВЕСТ'} width={elementWidth} specClassName='island_main_screen_board_quest' isChoose={true} onClick={() => {
                                this.setState({ islandPass: true });
                            }} />
                        }
                        <div className='island_main_island3_inner_separator' />
                        <div style={{ width: elementWidth }}>
                            <TrefaText trefaText={trefaText3_3} />
                        </div>
                        <div style={{ width: elementWidth }}>
                            <TrefaText trefaText={trefaText3_2} style={{ color: 'white', fontSize: isMobile ? 16 : 20 }} />
                        </div>
                        <div className='island_main_island3_inner_separator' />
                        <this.Board text={'КВЕСТ ТОТЕМА СОВЫ'} width={elementWidth} />
                        <div style={{ width: elementWidth }}>
                            <TrefaText trefaText={trefaText3_4} style={{ color: 'white', fontSize: isMobile ? 16 : 20 }} />
                        </div>
                        {(status !== 'nouser' && status !== 'noislanduser') &&
                            <this.Board text={'ПРОДОЛЖИТЬ КВЕСТ'} width={elementWidth} specClassName='island_main_screen_board_quest' isChoose={true} onClick={() => {
                                this.setState({ islandPass: true });
                            }} />
                        }
                        {(status === 'nouser') &&
                            <React.Fragment>
                                <this.Board trefaText={trefaText3_nouser} width={elementWidth} />
                                <br />
                                <Link to='/'>
                                    <this.Board text={'ВЕРНУТЬСЯ НА ГЛАВНУЮ'} specClassName='island_main_screen_board_secqence' width={elementWidth} isChoose={true} />
                                </Link>
                                <br />
                            </React.Fragment>
                        }
                        {(status === 'noislanduser') &&
                            <this.Board text={'НАЧАТЬ КВЕСТ'} width={elementWidth} specClassName='island_main_screen_board_quest' isChoose={true} onClick={() => {
                                this.setState({ status: 'loading', islandPass: true });
                                this.islandLogOnIsland();
                            }} />
                        }
                        <div className='island_main_island3_inner_separator' />
                        <this.Board text={'УПРАВЛЕНИЕ'} width={elementWidth} />
                        <div style={{ width: elementWidth }}>
                            <TrefaText trefaText={trefaText3_5} style={{ color: 'white', fontSize: isMobile ? 16 : 20 }} />
                        </div>
                        <div className='island_main_island3_inner_separator' />
                        <div className='island_main_island3_inner_separator' />
                        <br />
                        {/* <this.Board trefaText={trefaText3} width={elementWidth} style = {{ color: 'white', fontSize: 18 }} /> */}
                    </div>
                </div>
            }
            passToIsland = true;
        }

        if (!passToIsland) return <div className='island_main'>
            <div className='island_main_startscreen'>
                ЧТО ТО ПОШЛО НЕ ТАК
            </div>
        </div >



        if (isMobile) {

            const { showMenu } = this.state;

            return <div style={{ height: isMobile.height }} className='island_main'>

                {showMenu ? <React.Fragment>
                    <this.ThirdScreen />
                    <this.Board text={'К ИГРЕ'} width={isMobile.width * 0.95} isChoose={true} onClick={this.toggleShowMenu} />
                </React.Fragment>
                    :
                    <React.Fragment>
                        <this.ChooseScreen />
                        <this.ItemsScreen />
                        <this.MiniMapScreen />
                        <this.Board text={'МЕНЮ'} width={isMobile.width * 0.95} isChoose={true} onClick={this.toggleShowMenu} />
                    </React.Fragment>
                }
            </div>
        }


        const { point: { Type } = { Type: '' } } = this.state;

        if (Type === 'cave') {
            return <div className='island_main'>
                <this.CaveScreen />
            </div>
        }

        if (Type === 'shop') {
            return <div className='island_main'>
                <this.ShopScreen />
            </div>
        }

        // не мобильная вёрстка
        return <div className='island_main'>
            <this.ItemsScreen />
            <this.ChooseScreen />
            {/* <this.ActionsScreen /> */}
            <this.ThirdScreen />
        </div>


    }

    Board = ({ text, trefaText, width, height, isChoose, onClick = () => { }, specClassName = null }) => {
        const {
            screenWidth
        } = this.state;

        let boardStyle = {
            width: width || screenWidth * 0.96,
            minHeight: screenWidth * 0.08
        }
        if (height) boardStyle.height = height;

        let cantStyle = {
            width: screenWidth * 0.03,
            height: screenWidth * 0.03,
        }

        let className = 'island_main_screen_board ' + (isChoose ? 'island_main_screen_board_isChoose' : '')
        if (specClassName) className += ` ${specClassName}`;

        return <div onClick={onClick} style={boardStyle} className={className}>
            <div style={cantStyle} className='island_main_screen_board_cant island_main_screen_board_cant_lefttop' />
            <div style={cantStyle} className='island_main_screen_board_cant island_main_screen_board_cant_righttop' />
            <div style={cantStyle} className='island_main_screen_board_cant island_main_screen_board_cant_leftbottom' />
            <div style={cantStyle} className='island_main_screen_board_cant island_main_screen_board_cant_rightbottom' />
            {text && <span>{text}</span>}
            {trefaText && <TrefaText trefaText={trefaText} />}
        </div>
    }

    CaveScreen = () => {
        const {
            screenWidth,
            screenHeight,
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        const { point } = this.state;
        const { Settings } = point;
        const SettingsObj = Settings ? JSON.parse(Settings) : {};

        if (SettingsObj.caveId) {
            return <div style={style} className='island_main_screen island_main_screen_choosescreen'>
                <NgGameRPG caveId={SettingsObj.caveId} heightDirect={650} abandoneCave={this.abandoneCave} />
            </div>
        }
    }

    ShopScreen = () => {
        const {
            screenWidth,
            screenHeight,
        } = this.state;

        const { point } = this.state;
        const { Settings } = point;
        const SettingsObj = Settings ? JSON.parse(Settings) : {};

        if (SettingsObj.shopId) {
            return <div style={{ width: 1100, height: screenHeight }} className='island_main_screen island_main_screen_choosescreen'>
                <ShopPage shopId={SettingsObj.shopId} abondoneShop={this.abondoneShop} />
            </div>
        }
        return null;
    }

    ChooseScreen = () => {
        const {
            screenWidth,
            screenHeight,
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        const { point, location, chooses = [] } = this.state;

        console.log('chooses', chooses);

        const { Settings } = point;
        const SettingsObj = Settings ? JSON.parse(Settings) : {};
        let character = SettingsObj.character || null;

        let choosesCoords = chooses.filter(x => x.Type === 'coords') || [];

        const ChooseImage = () => {

            const containerStyle = {
                width: screenWidth,
                height: screenWidth / 1.9
            }

            const upperStyle = {
                width: screenWidth / 3,
                height: screenWidth / 12
            }

            const imageStyle = {
                width: screenWidth,
                height: screenWidth / 2
            }

            return <div style={containerStyle} className='island_main_screen_choosescreen_imagecontainer'>
                {point.Id === 11 && <Pump width={40} left={107} top={142} pumpCode={'iigjgha'} />}
                <div style={upperStyle} className='island_main_screen_choosescreen_imagecontainer_upper'>
                    <span>
                        {point.Title || location.Title}
                    </span>
                </div>
                {character && <Charater Id={character.Id} Mood={character.Mood} screenWidth={screenWidth} myActions={this.state.myActions} />}
                <img style={imageStyle} src={`/../images/ver2/island/screens/${point.Screen}.${point.Rez || 'jpg'}`} />
                {choosesCoords.map(({ Settings, Id }) => {
                    const SettingsObj = Settings ? JSON.parse(Settings) : {};
                    if (!SettingsObj.coordBox) return null;
                    const style = {
                        left: SettingsObj.coordBox.x * screenWidth,
                        top: SettingsObj.coordBox.y * screenWidth,
                        width: SettingsObj.coordBox.w * screenWidth,
                        height: SettingsObj.coordBox.h * screenWidth
                    }
                    return <div style={style} className='island_main_screen_choosescreen_imagecontainer_coords'
                        onClick={
                            () => {
                                if (this.state.status === 'waiting') {
                                    return;
                                }
                                this.makeAChoose({ ChooseId: Id })
                            }
                        }
                    />
                })}
            </div>
        }

        const Chooses = () => {
            return chooses.map(({ Id: ChooseId, Title, Type }) => {

                let specClassName = null;

                if (Type === 'admin') specClassName = 'island_main_screen_board_admin';
                if (Type === 'quest') specClassName = 'island_main_screen_board_quest';
                if (Type === 'seq') specClassName = 'island_main_screen_board_secqence';
                if (Type === 'disabled') specClassName = 'island_main_screen_board_waiting';
                if (Type === 'coords') return null;
                if (this.state.status === 'waiting') specClassName = 'island_main_screen_board_waiting';

                return this.Board({
                    text: Title, isChoose: this.state.status !== 'waiting',
                    specClassName,
                    onClick: () => {
                        if (this.state.status === 'waiting') {
                            return;
                        }
                        if (Type === 'disabled') {
                            if (this.state.IsAdmin) {
                                this.makeAChoose({ ChooseId })
                            }
                            return;
                        }
                        this.makeAChoose({ ChooseId })
                    }
                })
            })
        }

        let Special = null;
        if (point.Id === 20) {
            Special = <Quest20 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 27) {
            Special = <Quest27 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 36) {
            Special = <Quest36 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 66) {
            Special = <Quest66 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 103) {
            Special = <Quest103 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 105) {
            Special = <MainAdmin IslandId={this.IslandId} />
        }
        if (point.Id === 89) {
            Special = <Results89 IslandId={this.IslandId} MyTeamId={this.state.TeamId} />
        }
        if (point.Id === 114) {
            Special = <Quest27 sendSpecial={this.sendSpecial} text={'ВВЕСТИ КОД'} />
        }
        if (point.Id === 96) {
            Special = <Quest96 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 207) {
            Special = <Quest207 sendSpecial={this.sendSpecial} />
        }
        if (point.Id === 211) {
            Special = <Quest211 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }
        if (point.Id === 222) {
            Special = <Quest222 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }
        if (point.Id === 254) {
            Special = <Quest254 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }
        if (point.Id === 259) {
            Special = <Quest259 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }
        if (point.Id === 335) {
            Special = <Quest335 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }
        if (point.Id === 339) {
            Special = <Quest339 sendSpecial={this.sendSpecial} screenWidth={this.state.screenWidth} />
        }

        if (point.Type === 'round') {
            const { Settings } = point;
            if (Settings) {
                const SettingsObj = JSON.parse(Settings);
                const { RoundId } = SettingsObj;
                if (RoundId) {
                    Special = <Link to={`/round/${RoundId}`}>
                        <this.Board text='СВЯЗКА' isChoose={true} specClassName={'island_main_screen_board_secqence'} />
                    </Link>
                }
            }
        }


        if (point.Type === 'quest' && !Special) {
            Special = <Quest27 sendSpecial={this.sendSpecial} text={'ОТВЕТ'} />
        }

        return <div style={style} className='island_main_screen island_main_screen_choosescreen'>
            {ChooseImage()}
            <div className='island_main_screen_choosescreen_chooses'>
                {this.Board({ trefaText: point.Text || location.Text })}
                {Special}
                {Chooses()}
            </div>
        </div>

    }

    abondoneShop = () => {
        const { chooses = [] } = this.state;
        for (let i = 0; i < chooses.length; i++) {
            const { Type, Id } = chooses[i];
            if (Type === 'defback') {
                this.makeAChoose({ ChooseId: Id })
                return;
            }
        }
    }

    abandoneCave = (props) => {
        // this.makeAChoose({ ChooseId })

        const { IsPassed, nowBlockId } = props;

        const { point, chooses = [] } = this.state;
        const { Settings } = point;
        const SettingsObj = Settings ? JSON.parse(Settings) : {};
        const { exits = {} } = SettingsObj;

        if (!IsPassed) {
            for (let i = 0; i < chooses.length; i++) {
                const { Type, Id } = chooses[i];
                if (Type === 'defback') {
                    this.makeAChoose({ ChooseId: Id })
                    return;
                }
            }
            return;
        }

        // если прошли
        if (exits[nowBlockId]) {
            const ChooseId = exits[nowBlockId];
            this.makeAChoose({ ChooseId })
        }
    }

    ItemsScreen = () => {
        const {
            screenWidth,
            screenHeight,
            Items,
            combineMode
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        return <div style={style} className='island_main_screen island_main_screen_itemsscreen'>
            <PersonInventar IslandId={this.IslandId} Items={Items} useItem={this.useItem} combineMode={combineMode} addCombineItem={this.addCombineItem} />
            <div className='island_main_screen_itemsscreen_combine' onClick={() => {
                if (combineMode) {
                    return this.setCompineMode()
                }
                this.setCompineMode({})
            }}>
                <span>
                    {combineMode ? 'Выберите предметы' : 'КОМБИНИРОВАТЬ'}
                </span>
            </div>
        </div>

    }

    ActionsScreen = () => {
        const {
            screenWidth,
            screenHeight,
            myActions = []
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        let myActions_ = [...myActions];
        myActions_.reverse();

        return <div style={style} className='island_main_screen_actionsscreen'>
            {myActions_.map(({ Title }) => {
                return <span key={'123dgfg' + Title}>{Title}</span>
            })}
        </div>

    }

    HelpScreen = () => {
        const {
            screenWidth
        } = this.state;

        const style = {
            width: screenWidth
        }


        return <div style={style} className='island_main_screen_actionsscreen'>
            Приветствую Вас в интерактивной игре Остров на портале capoeirasport.<br />
            Это первая попытка запустить подобный проект, поэтому могут быть какие-то ошибки, просьба отнестись с пониманием.
            <br /><br />
            <b>УПРАВЛЕНИЕ</b>
            Вы всегда находитесь в определённой локации. Её название, соответствующая картинка и текстовое описание отображаются в верхней части.<br />
            К каждой локации есть варианты действий, который Вы можете совершить. Варианты могут меняться в зависимости от ранее совершенных действий в игре.<br />
            По сути, Вы продвигаетесь по игре, совершая те или иные действия. Список ключевых действий, которые Вы уже совершили, и которые влияют на игровой процесс отображаются во вкладке Логи.
            <br /><br />
            <b>ИНВЕНТАРЬ</b>
            В игре присутствует инвентарь: по ходу прохождения Вы будете получать разные предметы.
            Предметы деляется на материальные -обозначаются буквой Q- и Ваши мысли -обозначаются символом разговора-<br /><br />
            Что можно с ними делать? <br />
            ОСМОТРЕТЬ - навести и нажать значок лупа, чтобы прочитать описание предмета.<br />
            ПРИМЕНИТЬ - навести и нажать значок стрелки вверх. Предмет применяется в текущей локации, если это предусмотрено прохождением.<br />
            КОМБИНИРОВАТЬ - нажать на соответствующую кнопку внизу инвентаря, после чего навести и выбрать плюсик первого предмета, затем второго<br />
            <br /><br />
            <b>ЗАГАДКИ</b>
            В игре есть несколько загадок, каждая из которых решается в отдельной форме. Они рассчитаны на логику, внимательность, и, зачастую, знания различных аспектов, связанных с капоэйра.
            <br /><br />
            <b>ПОДСКАЗКИ ПО ПРОХОЖДЕНИЮ</b>
            1 - не спешите перетыкивать всё на всём. Многие решения, хотя и могут быть не тривиальными, почти всегда опираются на логику ситуации.<br />
            2 - использование предметов чувствительно к конкретной локации. Так, чтобы попытаться обсудить с кем-то мысль или предмет из инвентаря, их надо применять в локации инициации диалога, а не в ходе его действия или где-то рядом.<br />
            3 - не забывайте про возможность комбинировать предметы, эта кнопка часто выпадает из вида и забывается.<br />
            4 - не стесняйтесь обратиться за помощью к старшим. Если Вы совсем не знаете, как решить ту или иную задачу - опишите её, и попросите помощи у кого-нибудь из капоэйристов.<br />
            Или пишите администратору портала, помогу чем смогу :D
            <br /><br />
            <b>ОБЯЗАТЕЛЬНО ЛИ ВЫПОЛНЯТЬ СВЯЗКИ В БАШНЯХ</b>
            Не обязательно. Изначальный концепт игры предполагал, что пока Вы не заявите и не пришлёте связку из башни, Вы не сможете совершить то или иное ключевое действие.
            <br />Но так как сейчас игра, по сути, тестируется - это просто возможность для Вас выполнить связку, которую Вам хочется и получить дополнительную статистику по элементам.
            <br /><br />
            <b>КАРТА</b>
            В игре присутствует карта острова. Если Вы зашли с мобильного приложения - ей можно развернуть, нажав на миниаютру в верхней левой части.
            <br />Карта отображает Ваше текущее положение, чтобы проще было ориентироваться.
            <br /><br />
            <b>КАК ВЕРНУТЬСЯ НА ГЛАВНУЮ СТРАНИЦУ</b>
            Нажать сюда, Ваш прогресс в игре не сбросится
            <Link to='/'>
                <div className='island_button_exit'>
                    <span>ВЫХОД</span>
                </div>
            </Link>
            <br /><br />
            Удачного прохождения! Буду невероятно благодарен за обратную связь, с радостью отвечу на любые вопросы!
        </div>

    }

    MapScreen = () => {
        const {
            screenWidth,
            screenHeight,
            LocationId
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        if (!LocationId) {
            return null;
        }

        const mapWidth = screenWidth;
        const mapHeight = screenWidth * 1.3646;

        let mapStyle = {
            width: mapWidth,
            height: mapHeight
        }

        const locWidth = mapWidth * 0.05;
        const locHeight = locWidth * 1.34;

        const locStyle = {
            width: locWidth,
            height: locHeight,
            left: ISLAND_LOC[this.IslandId][LocationId] ? (ISLAND_LOC[this.IslandId][LocationId].x * 0.001 * mapWidth) : 0,
            top: ISLAND_LOC[this.IslandId][LocationId] ? (ISLAND_LOC[this.IslandId][LocationId].y * 0.001 * mapWidth) : 0,
        }

        let classNameMap = 'island_main_screen_mapscreen_inner';
        if (this.IslandId !== 1) {
            classNameMap += ` island_main_screen_mapscreen_inner${this.IslandId}`;
        }

        return <div style={mapStyle} className={classNameMap}>
            <div style={locStyle} className='island_main_screen_mapscreen_loc' />
        </div>
    }

    ThirdScreen = () => {
        const {
            screenWidth,
            screenHeight
        } = this.state;

        const style = {
            width: screenWidth,
            height: screenHeight
        }

        const { isMobile } = this.props;

        if (isMobile) {
            return <div style={style} className='island_main_screen island_main_screen_thirdscreen'>
                <Tabs tabPosition='top' defaultActiveKey='1'>
                    <TabPane tab='Помощь' key='1'>
                        <this.HelpScreen />
                    </TabPane>
                    <TabPane tab='Логи' key='2'>
                        <this.ActionsScreen />
                    </TabPane>
                    <TabPane tab='Выход' key='3'>
                        <div className='island_main_screen_actionsscreen'>
                            Ваш прогресс в игре не сбросится, Вы просто перейдёте на главную страницу Портала. Когда вернётесь, начнёте с того же места.
                            <Link to='/'>
                                <div className='island_button_exit'>
                                    <span>ВЫХОД</span>
                                </div>
                            </Link>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        }


        return <div style={style} className='island_main_screen island_main_screen_thirdscreen'>
            <Tabs tabPosition='top' defaultActiveKey='1'>
                <TabPane tab='Карта' key='1'>
                    <this.MapScreen />
                </TabPane>
                <TabPane tab='Логи' key='2'>
                    <this.ActionsScreen />
                </TabPane>
                <TabPane tab='Помощь' key='3'>
                    <this.HelpScreen />
                </TabPane>
            </Tabs>
        </div>
    }


    MiniMapScreen = () => {
        const {
            screenWidth,
            screenHeight,
            LocationId,
            miniMapFull
        } = this.state;

        const koef = miniMapFull ? 0.98 : 0.23;

        const miniMapWidth = screenWidth * koef;
        const miniMapHeight = miniMapWidth * 1.3646;

        let style = {
            width: miniMapWidth,
            height: miniMapHeight / 2
        }

        if (!LocationId) {
            return null;
        }

        const mapWidth = miniMapWidth;
        const mapHeight = miniMapHeight;

        const mapStyle = {
            width: mapWidth,
            height: mapHeight
        }

        const locWidth = mapWidth * 0.05;
        const locHeight = locWidth * 1.34;

        const locStyle = {
            width: locWidth,
            height: locHeight,
            left: ISLAND_LOC[this.IslandId][LocationId] ? (ISLAND_LOC[this.IslandId][LocationId].x * 0.001 * mapWidth) : 0,
            top: ISLAND_LOC[this.IslandId][LocationId] ? (ISLAND_LOC[this.IslandId][LocationId].y * 0.001 * mapWidth) : 0,
        }

        let className = 'island_main_screen_minimapscreen';
        if (miniMapFull) className += ' island_main_screen_minimapscreen_full';

        let classNameMap = 'island_main_screen_mapscreen_inner';
        if (this.IslandId !== 1) {
            classNameMap += ` island_main_screen_mapscreen_inner${this.IslandId}`;
        }

        return <div onClick={this.toggleMiniMapFull} style={style} className={className}>
            <div style={mapStyle} className={classNameMap}>
                <div style={locStyle} className='island_main_screen_mapscreen_loc' />
            </div>
        </div>
    }

}


export default withCapoeiraSportState('iamuser, client, isMobile, renewResourses, doShowFooter')(IslandPage);